export default __webpack_public_path__ + "static/TSI-Trading_Standards-White-f08ac79c99741adb802568020aafe1a8.png";